import React from "react";
import { Address } from "../../../api/services";
import { Box, Typography } from "@material-ui/core";
import { formatAddress } from "../../../utils/formatAddress";
import { FormSectionHeading } from "../../../components/Forms/FormSectionHeading";

interface ContactAddressProps {
  address?: Address;
}

export const ContactAddress: React.FC<ContactAddressProps> = ({ address }) => {
  return (
    <>
      <FormSectionHeading>Billing Address *</FormSectionHeading>
      <Box mt={3}>
        <Typography variant="subtitle1">
          {address ? formatAddress(address) : "Unknown"}
        </Typography>
      </Box>
    </>
  );
};
